export const scrollToId = (elementTag: string): void => {
  const element = document.getElementById(elementTag);

  if (!!element) {
    for (let i = 0; i < element.offsetTop - 80 /*Header height*/; i++) {
      setTimeout(() => {
        window.scrollTo(0, i);
      }, 0.1 * i);
    }
  }
};
